import { api } from '../api';
import { provider, tags } from '../tags';
import type { PhoneValidateToken, PhoneVerification } from '../types';

/* istanbul ignore file */

export const phoneVerifyApi = api.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    PhoneVerifications: builder.query<Array<PhoneVerification>, void>({
      query: () => 'api/phoneverify/',
      providesTags: provider<PhoneVerification>(tags.phoneVerification),
    }),

    phoneVerify: builder.mutation<PhoneVerification, PhoneVerification>({
      query: (data) => ({
        url: data.id ? `api/phoneverify/${data.id}/` : 'api/phoneverify/',
        method: data.id ? 'PATCH' : 'POST',
        body: data,
      }),
      invalidatesTags: [tags.phoneVerification],
    }),

    phoneTokenValidation: builder.mutation<PhoneValidateToken, PhoneValidateToken>({
      query: (data) => ({
        url: `api/phonevalidatetoken/${data.id}/`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: [tags.phoneVerification],
    }),
  }),
});
